import { sectionLabels } from "../section-labels";
/**
 * Floating buy bar — the desktop buy layer EasyOrders pins to the viewport as
 * the shopper scrolls the PDP: a thumb + name/price + Buy-now (and, in the
 * full-width variant, a quantity stepper). Previously this lived inside the
 * `product-buybox` section as the `stickyBuyBar*` settings; it's now its own
 * selectable product-template section so the seller can pick its variant and
 * visibility on the canvas, independent of the buy box.
 *
 * Rendered as fixed chrome by the PDP (not in the page flow), so its position
 * in the section list doesn't change where it appears. Two variants mirror EO:
 *  · `buybar-full-width` — a bar across the viewport bottom (with qty stepper).
 *  · `buybar-floating`   — a compact rounded card anchored bottom-end (no qty).
 */
export const productBuybarSchema = {
    type: "product-buybar",
    name: sectionLabels["product-buybar"],
    description: {
        ar: "شريط الشراء اللي بيثبت أسفل الشاشة على الكمبيوتر وأنت بتنزل في صفحة المنتج.",
        en: "The desktop buy bar pinned to the bottom of the screen as the shopper scrolls the product page.",
    },
    availableOnTemplates: ["product"],
    maxPerTemplate: 1,
    settings: [
        {
            id: "variant",
            type: "select",
            ui: "thumbnail",
            label: { ar: "شكل الشريط", en: "Bar style" },
            helpText: {
                ar: "شريط بعرض الشاشة (مع الكمية)، أو بطاقة عائمة في الركن.",
                en: "A full-width bar (with quantity), or a floating card anchored in the corner.",
            },
            options: [
                {
                    value: "buybar-full-width",
                    label: { ar: "شريط كامل العرض", en: "Full-width bar" },
                },
                {
                    value: "buybar-centered",
                    label: { ar: "شريط موسّط", en: "Centered bar" },
                },
                {
                    value: "buybar-centered-sharp",
                    label: { ar: "شريط موسّط حاد", en: "Centered bar (sharp)" },
                },
                {
                    value: "buybar-stacked",
                    label: { ar: "شريط بزر كامل العرض", en: "Stacked (full-width button)" },
                },
                {
                    value: "buybar-floating",
                    label: { ar: "بطاقة عائمة", en: "Floating card" },
                },
            ],
            default: "buybar-full-width",
        },
        {
            id: "behavior",
            type: "select",
            label: { ar: "ظهور الشريط", en: "Bar visibility" },
            helpText: {
                ar: "دايمًا ظاهر، أو يظهر بعد ما ينزل الزائر لتحت.",
                en: "Always visible, or revealed after the shopper scrolls down.",
            },
            options: [
                { value: "always-on", label: { ar: "دايمًا ظاهر", en: "Always visible" } },
                { value: "on-scroll", label: { ar: "يظهر عند النزول", en: "On scroll" } },
            ],
            default: "always-on",
        },
    ],
};
//# sourceMappingURL=product-buybar.js.map